import Image from "next/image";
import { useRouter } from "next/router";
import { TYPO } from "styles/Typo";

function BriefingHeader({
  title,
  isMobile,
}: {
  title?: string;
  isMobile: boolean;
}) {
  const router = useRouter();
  return (
    <div
      className={`h-14 py-[3px] relative w-full flex justify-center items-center ${
        isMobile ? "bg-gray2" : "bg-white"
      }`}
    >
      <div
        className="back absolute top-[50%] left-[4px] translate-y-[-50%] p-3 cursor-pointer"
        onClick={() => {
          // router.back();
          router.push("/?type=feed");
        }}
      >
        <Image
          src={"/images/icons/back.svg"}
          alt="arrow"
          width={24}
          height={24}
        />
      </div>
      {title && <span className={`${TYPO.TYPO6_SB} text-gray80`}>{title}</span>}
    </div>
  );
}
export default BriefingHeader;
